import Classnames from 'classnames'
import { useAtom } from 'jotai'
import produce from 'immer'

// helper functions
import {
  returnValue,
  returnUserContent,
  returnBlockValue,
} from '@/utils/op-types/helperFunctions'

// store
import {
  isBuilder,
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
  userContents,
} from '@/utils/op-types/store'

const Block = ({ id, block, design, content }) => {
  const [builder] = useAtom(isBuilder)
  // manifest settings
  const [opStatic] = useAtom(manifestStatic)
  const [opDesign] = useAtom(manifestDesign)
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [pageStatic] = useAtom(pageContentStatic)
  const [pageDesign] = useAtom(pageContentDesign)
  const [pageBlocks] = useAtom(pageContentBlocks)
  const [getUserContents, setUserContents] = useAtom(userContents)

  let borderWidth = returnBlockValue(
    'borderwidth',
    'design',
    opBlocks[block],
    design
  )
  let borderVisible = returnBlockValue(
    'bordervisible',
    'design',
    opBlocks[block],
    design
  )

  if (borderVisible === 'false') {
    borderWidth = 0
  }

  return (
    <div
      className={Classnames(
        'mx-auto opr-card opr-cardcontent flex items-center bg-white p-12 rounded-lg  border',
        returnBlockValue('dropshadow', 'design', opBlocks[block], design)
      )}
      style={{
        backgroundColor: returnBlockValue(
          'background',
          'design',
          opBlocks[block],
          design
        ),
        color: returnBlockValue('textcolor', 'design', opBlocks[block], design),
        borderColor: returnBlockValue(
          'bordercolor',
          'design',
          opBlocks[block],
          design
        ),
        marginBottom: `${returnBlockValue(
          'marginbottom',
          'design',
          opBlocks[block],
          design
        )}px`,
        borderWidth: `${borderWidth}px`,
        maxWidth: '800px',
      }}
    >
      <div
        className={Classnames('w-2/3', {
          'order-last pl-12':
            returnBlockValue(
              'imageposition',
              'design',
              opBlocks[block],
              design
            ) == 'left',
          'pr-12':
            returnBlockValue(
              'imageposition',
              'design',
              opBlocks[block],
              design
            ) == 'right',
        })}
      >
        <h2 className="text-3xl font-bold mb-2">
          {returnBlockValue('headline', 'content', opBlocks[block], content)}
        </h2>

        <div
          className="text-md space-y-4"
          dangerouslySetInnerHTML={{
            __html: returnBlockValue(
              'text',
              'content',
              opBlocks[block],
              content
            ),
          }}
        ></div>
      </div>
      <div className="w-1/3">
        <img
          src={returnBlockValue('image', 'content', opBlocks[block], content)}
          className="w-full rounded"
        />
      </div>
    </div>
  )
}

export default Block
